import React from 'react';
import { makeStyles } from '@mui/styles';
import Benefits from '../Benefits';

const useStyles = makeStyles((theme) => ({
  headingWrapper: {
    padding: '50px 15px 32px',
    maxWidth: 665,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '50px 32px 32px',
    },
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: 600,
    margin: '0 0 20px',
  },
  sectionText: {
    fontSize: 16,
  },
}));

function BenefitsBlock() {
  const classes = useStyles();

  const benefitsData = [
    {
      title: 'Simplify Gathered Data',
      text: 'Often, graphs and statistics are complicated and don’t clearly state the information they are meant to convey. Paraphrasing the results or conclusions can be an effective way to communicate the importance of the data to your audience.',
      background: '#EDFFF0',
    },
    {
      title: 'Keep Writing Concise',
      text: 'Many writers go into too much detail about certain topics, which can make their writing both long-winded and overly technical. Adding a quick paraphrase helps a general audience understand an idea more quickly and comprehensively without adding so much text.',
      background: '#CAFCD4',
    },
    {
      title: 'Explain Ideas Simply',
      text: "Whether you're explaining research to a friend or telling them about your favorite line in a movie, paraphrasing helps you quickly and simply reiterate the relevant information.",
      background: '#8FE39E',
    },
    {
      title: 'Establish Credibility',
      text: 'Paraphrasing an interesting quote or research finding by a prominent author can be an effective way to reel in audiences and improve the credibility of your writing by citing high-quality sources.',
      background: '#61C774',
    },
  ];

  return (
    <>
      <div className={classes.headingWrapper}>
        <h2 className={classes.sectionTitle}>When Should Paraphrasing Be Used?</h2>
        <div className={classes.sectionText}>
          Choosing to paraphrase is often a smart decision, but in academic writing and in the
          professional world, it should only be used under certain circumstances. Let’s take a look
          at when paraphrasing can and should be used.
        </div>
      </div>
      <Benefits data={benefitsData} />
    </>
  );
}

export default BenefitsBlock;
